import _classCallCheck from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import ArrowLeft from '@material-ui/icons/ChevronLeft';
import ArrowRight from '@material-ui/icons/ChevronRight';
import Ellipsis from '@material-ui/icons/MoreHoriz';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
export var createArray = function createArray(pages, active) {
  if (!pages) return [];

  if (pages < 8) {
    return Array(pages).fill().map(function (page, i) {
      return i + 1;
    });
  } else if (active < 5) {
    return Array(7).fill().map(function (page, i) {
      var index = i + 1;

      if (index === 6) {
        return -1;
      } else if (index === 7) {
        return pages;
      } else {
        return index;
      }
    });
  } else if (active > pages - 4) {
    return Array(7).fill().map(function (page, i) {
      var index = i + 1;

      if (index === 2) {
        return -1;
      } else if (index === 1) {
        return 1;
      } else {
        var diff = index - 7;
        return pages + diff;
      }
    });
  } else {
    return Array(7).fill().map(function (page, i) {
      var index = i + 1;

      if (index === 6 || index === 2) {
        return -1;
      } else if (index === 1) {
        return 1;
      } else if (index === 7) {
        return pages;
      } else {
        var diff = index - 4;
        return active + diff;
      }
    });
  }
};

var DefiPagination =
/*#__PURE__*/
function (_Component) {
  _inherits(DefiPagination, _Component);

  function DefiPagination() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DefiPagination);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DefiPagination)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      active: 1,
      pagination: [1]
    };
    return _this;
  }

  _createClass(DefiPagination, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.setPaginationOptions();

      if (this.props.page && this.props.page !== this.state.active) {
        this.setState({
          active: this.props.page
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.active !== this.state.active || this.props.pages !== prevProps.pages) {
        this.setPaginationOptions();
      }

      if (this.props.page !== this.state.active) {
        this.setState({
          active: this.props.page
        });
      }

      if (this.props.pages && this.props.pages !== this.state.pagination[this.state.pagination.length - 1]) {
        this.setState({
          pagination: this.setPaginationOptions('update')
        });
      }
    }
  }, {
    key: "setPaginationOptions",
    value: function setPaginationOptions(update) {
      var active = this.state.active;
      var arr = createArray(this.props.pages, active);

      if (update) {
        return arr;
      } else {
        this.setState({
          pagination: arr
        });
      }
    }
  }, {
    key: "left",
    value: function left() {
      var page = this.state.active - 1;
      this.props.changePage({
        page: page
      });
      this.setState({
        active: page
      });
    }
  }, {
    key: "right",
    value: function right() {
      var page = this.state.active + 1;
      this.props.changePage({
        page: page
      });
      this.setState({
        active: page
      });
    }
  }, {
    key: "select",
    value: function select(page) {
      this.props.changePage({
        page: page
      });
      this.setState({
        active: page
      });
    }
  }, {
    key: "renderList",
    value: function renderList() {
      var _this2 = this;

      var _this$state = this.state,
          active = _this$state.active,
          pagination = _this$state.pagination;
      var classes = this.props.classes;
      var list = pagination.map(function (page, i) {
        if (page === -1) {
          return React.createElement(Ellipsis, {
            focusable: "focusable",
            key: i,
            className: "".concat(classes.item, " ").concat(classes.ell)
          });
        }

        return React.createElement("li", {
          key: i,
          className: active === page ? "".concat(classes.active, " ").concat(classes.item, " ").concat(classes.number, " Page-").concat(page) : "not-active ".concat(classes.item, " ").concat(classes.number, " Page-").concat(page),
          onClick: active !== page ? function () {
            return _this2.select(page);
          } : function () {
            return null;
          },
          "data-testid": "page-".concat(page)
        }, page);
      });
      return list;
    }
  }, {
    key: "renderResults",
    value: function renderResults() {
      var records = this.props.records;
      var recordsText = '';

      if (records) {
        recordsText += records;
      } else {
        recordsText += 'No';
      }

      recordsText += ' Result';

      if (records > 1 || records < 1 || records === undefined) {
        recordsText += 's';
      }

      return recordsText;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var active = this.state.active;
      var _this$props = this.props,
          classes = _this$props.classes,
          pages = _this$props.pages,
          records = _this$props.records;
      return React.createElement(Grid, {
        container: true,
        spacing: 10,
        "data-testid": "pagination"
      }, React.createElement(Grid, {
        item: true,
        xs: 1,
        sm: 3
      }), React.createElement(Grid, {
        item: true,
        xs: 6,
        sm: 6
      }, React.createElement("center", {
        className: classes.center
      }, React.createElement("ul", {
        className: classes.pagination
      }, active > 1 ? React.createElement(ArrowLeft, {
        "data-testid": "arrow-left",
        focusable: "focusable",
        className: "".concat(classes.item, " ").concat(classes.arrow),
        onClick: function onClick() {
          return _this3.left();
        }
      }) : React.createElement("li", {
        className: "".concat(classes.item, " ").concat(classes.blank)
      }), this.renderList(), active < pages && pages > 1 ? React.createElement(ArrowRight, {
        "data-testid": "arrow-right",
        focusable: "focusable",
        className: "".concat(classes.item, " ").concat(classes.arrow),
        onClick: function onClick() {
          return _this3.right();
        }
      }) : React.createElement("li", {
        className: "".concat(classes.item, " ").concat(classes.blank)
      })))), React.createElement(Grid, {
        item: true,
        xs: 4,
        sm: 3
      }, React.createElement("div", {
        className: classes.results,
        "data-testid": "results"
      }, this.renderResults())));
    }
  }]);

  return DefiPagination;
}(Component);

export default withStyles(styles)(DefiPagination);